import React from "react";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Text,
  Flex,
  Button,
  Divider,
  useDisclosure,
} from "@chakra-ui/react";

import Topbar from "components/topbar";
import MainLayout from "components/mainLayout";
import ShipmentSummaryModal from "./ShipmentSummaryModal";
import { useShipmentForm } from "context/DHLShipmentFormContext";
import { Form, Formik } from "formik";
import TextInput from "./components/TextInput";
import { useUserContext } from "context/UserContext";

const ShipmentEmail = () => {
  // const [value, setValue] = useState("");
  const { user, setUser, signOut } = useUserContext();

  console.log("user", user?.info?.email_address);
  const navigate = useNavigate();
  const { formData, updateFormData } = useShipmentForm();
  const {
    isOpen: isSummaryModalOpen,
    onOpen: onSummaryModalOpen,
    onClose: onSummaryModalClose,
  } = useDisclosure();

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required*"),
  });

  const initialValues = {
    email:
    user?.info?.email_address,
    phone: "+923001234567",
  };

  console.log("test form fdata[[[[====?", formData);

  return (
    <MainLayout>
      <Flex minH={"100%"} h={"100%"} bg={"#f8fbff"} flexDirection={"column"}>
        <Topbar title={"SHIP THROUGH DHL"} />
        <Flex
          flex={1}
          direction={"column"}
          bg={"#FFFFFF"}
          margin={4}
          padding={6}
          borderRadius={"16px"}
          gap={6}
        >
          {/* <Box> */}
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
            color={"#000000"}
          >
            Create Shipment
          </Text>
          <Divider bg={"#8A8F9333"} h={"1px"} />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              updateFormData({
                dropoff: {
                  ...formData?.dropoff,
                  notifications: [
                    {
                      email: values?.email,
                      phone: values?.phone,
                    },
                  ],
                },
              });
              onSummaryModalOpen();
            }}
          >
            {(formik) => (
              <Form
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  height: "100%",
                }}
              >
                <Box>
                  <Flex flexDirection={"column"} gap={6}>
                    <Box>
                      <Text
                        color={"#000000"}
                        fontFamily="PlusJakartaSansSemiBold"
                        fontSize={"16px"}
                        lineHeight={"22px"}
                        textTransform={"capitalize"}
                        mb={2}
                      >
                        Enter your email address to get your QR code?
                      </Text>
                      <Box
                        border="1px solid #D9D9D9"
                        borderRadius="8px"
                        p={4}
                        gap={4}
                        display={"flex"}
                        flexDirection={"column"}
                      >
                        <TextInput
                          formik={formik}
                          name="email"
                          placeholder={"Enter Email Address"}
                          label={"Email"}
                          labelColor={"#000000"}
                          disabled
                        />
                      </Box>
                    </Box>
                  </Flex>
                </Box>
                <Flex mt={4} gap={2} flex={1} alignItems={"flex-end"}>
                  <Flex>
                    <Button
                      onClick={() => navigate(-1)}
                      width={"148px"}
                      borderRadius={8}
                      bg={"none"}
                      border={"1px solid #000000"}
                      color={"#000000"}
                      fontSize={"12px"}
                      fontWeight={"500"}
                      fontFamily={"PlusJakartaSansMedium"}
                      letterSpacing={0.2}
                    >
                      Back
                    </Button>
                  </Flex>
                  <Flex justifyContent={"flex-end"} flex={1} w={"100%"} gap={2}>
                    <Button
                      onClick={() => {
                        formik.handleSubmit();
                      }}
                      flex={1}
                      maxW={"148px"}
                      background={"#000000"}
                      color={"#FFFFFF"}
                      borderRadius={8}
                      fontSize={"12px"}
                      fontFamily={"PlusJakartaSansMedium"}
                      textTransform={"uppercase"}
                      // isDisabled={}
                      _disabled={{
                        bg: "grey.100",
                        cursor: "default",
                        _hover: {
                          bg: "grey.100",
                          cursor: "default",
                        },
                      }}
                    >
                      Next
                    </Button>
                  </Flex>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
      </Flex>
      <ShipmentSummaryModal
        isOpen={isSummaryModalOpen}
        onClose={onSummaryModalClose}
      />
    </MainLayout>
  );
};

export default ShipmentEmail;
